import React, { useState } from 'react'
import Spinwheel from '../Spinwheel'
import Select from 'react-select';


function SentNotificaionModal({ sendNotificationHandler, selectTypeHandler, formik, loader, modalId }) {

  const selectionsOptions = [
    { label: 'User', value: 'user' },
    { label: 'Partner user', value: 'partnerUser' },
  ];

  const partnerOptions = [
    { label: "Driver", value: "driver" },
    { label: "Restaurant", value: "restaurant" }
  ];

  return (
    <>

      <div
        className="modal fade"
        id={modalId}
        tabIndex="-1"
        aria-labelledby="deleteModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog  modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header border-0">
              <button
                id="confirmModalCloseBtn"
                type="button"
                className="btn-close block-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body pe-0 ps-0">
              <div className="container">
                <h2>Notification</h2>
               <form onSubmit={formik.handleSubmit}>

                  {/* FIRST DROPDOWN */}
                  <div className="mb-3">
                    <label className="form-label">User type</label>

                    <Select
                      id="type"
                      name="type"
                      options={selectionsOptions}
                      value={formik.values.type}
                      onChange={(val) => {
                        formik.setFieldValue("type", val);
                        formik.setFieldValue("partnerType", ""); // reset second dropdown
                      }}
                      onBlur={() => formik.setFieldTouched("type", true)}
                    />

                    {formik.touched.type && formik.errors.type && (
                      <div className="req-error">{formik.errors.type}</div>
                    )}
                  </div>

                  {formik.values.type?.value === "partnerUser" && (
                    <div className="mb-3">
                      <label className="form-label">Select Partner Type</label>

                      <Select
                        id="partnerType"
                        name="partnerType"
                        options={partnerOptions}
                        value={formik.values.partnerType}
                        onChange={(val) =>
                          formik.setFieldValue("partnerType", val)
                        }
                        onBlur={() => formik.setFieldTouched("partnerType", true)}
                      />

                      {formik.touched.partnerType && formik.errors.partnerType && (
                        <div className="req-error">{formik.errors.partnerType}</div>
                      )}
                    </div>
                  )}

                  <button type="submit" disabled={loader} className="btn btn-primary">
                    {loader ? <Spinwheel sizeClass={"spin-small"} /> : "Send"}
                  </button>

                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default SentNotificaionModal